import React, { memo, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { structure } from '@dofleini/location'
import { createMapEntityToOptions } from '../../utils/createMapEntityToOptions'
import map from 'lodash/map'

const { MUNICIPALITIES } = structure
const mapOptionsFn = createMapEntityToOptions({
  keyLabel: 'name',
  keyValue: 'code'
})

const Municipalities = ({
  value,
  canClear,
  maxItems,
  onChange,
  provAcr,
  canSearch,
  autoFill,
  ...props
}) => {
  const [municipalities, setMunicipalities] = useState([])

  useEffect(() => {
    if (provAcr) {
      if (typeof provAcr === 'object') {
        const arr = []
        provAcr.forEach((prov) => {
          arr.push(...(MUNICIPALITIES[prov] || []))
        })
        setMunicipalities(arr)
      } else {
        setMunicipalities(MUNICIPALITIES[provAcr] || [])
      }
      const elements = MUNICIPALITIES[provAcr]
      if (!value) {
        if (autoFill) {
          onChange && onChange(elements && elements[0]?.code)
        } else {
          onChange && onChange([])
        }
      }
    }
  }, [value, provAcr])

  const options = useMemo(() => {
    if (provAcr && municipalities) {
      return map(municipalities, mapOptionsFn)
    }
    return []
  }, [municipalities, provAcr])

  return (
    <Select
      mode='multiple'
      allowClear={canClear}
      style={{ minWidth: 150 }}
      maxTagCount={maxItems || 3}
      onChange={onChange}
      defaultValue={value || []}
      value={value}
      options={options}
      filterOption={(input, option) =>
        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      showSearch={canSearch}
      {...props}
    />
  )
}

export default memo(Municipalities)

Municipalities.propTypes = {
  canClear: PropTypes.bool,
  canSearch: PropTypes.bool,
  maxItems: PropTypes.number,
  autoFill: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  provAcr: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

Municipalities.defaultProps = {
  autoFill: false
}
